import { NgTemplateOutlet } from '@angular/common';
import { Component, input, model, signal } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import {
  FormValidationComponent,
  InputCheckboxComponent,
} from '@pedix-workspace/angular-ui-form-reactive';
import {
  IconLoadingComponent,
  IconPriceDiscountComponent,
  IconShippingComponent,
} from '@pedix-workspace/angular-ui-icons';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { DeliveryType, TypesOfShippings } from '@pedix-workspace/utils';
import { ShippingCostResponse } from '@pedix-workspace/shared-delivery';

@UntilDestroy()
@Component({
  selector: 'app-shipping-cost-response',
  templateUrl: './shipping-cost-response.component.html',
  styleUrls: ['./shipping-cost-response.component.scss'],
  standalone: true,
  imports: [
    TranslocoDirective,
    AlertComponent,
    InputCheckboxComponent,
    FormValidationComponent,
    FormsModule,
    NgTemplateOutlet,
    CurrencyFormatPipe,
    IconPriceDiscountComponent,
    IconLoadingComponent,
    IconShippingComponent,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingCostResponseComponent {
  readonly calculatingShippingCost = input.required<boolean>();
  readonly shippingCostResponse = input.required<ShippingCostResponse | null>();
  readonly isFormSubmitted = input.required<boolean>();

  readonly outOfDeliveryZoneConfirmed = signal<boolean>(false);

  protected typesOfShippings = TypesOfShippings;
  protected deliveryTypes = DeliveryType;
}
